'use client';

import React from 'react';
import { ErrorBoundary } from '@/src/components/ErrorBoundary/ErrorBoundary';
import { GlobalErrorHandler } from '@/src/components/GlobalErrorHandler/GlobalErrorHandler';

export function AppErrorBoundary({ children }: { children: React.ReactNode }) {
  return (
    <ErrorBoundary>
      <GlobalErrorHandler />
      {children}
    </ErrorBoundary>
  );
}
